import { Transitivity } from "@protos/sca/v1/sca";

export const VULN_TRANSITIVITY_OPTIONS = [
  {
    label: "Direct",
    value: Transitivity.DIRECT,
  },
  {
    label: "Transitive",
    value: Transitivity.TRANSITIVE,
  },
  {
    label: "Undetermined",
    value: Transitivity.UNKNOWN_TRANSITIVITY,
  },
];
